__turbopack_context__.v({
  "actions": "status-page-module-scss-module__WUWl4q__actions",
  "card": "status-page-module-scss-module__WUWl4q__card",
  "code": "status-page-module-scss-module__WUWl4q__code",
  "help": "status-page-module-scss-module__WUWl4q__help",
  "page": "status-page-module-scss-module__WUWl4q__page",
  "primary": "status-page-module-scss-module__WUWl4q__primary",
  "secondary": "status-page-module-scss-module__WUWl4q__secondary",
  "text": "status-page-module-scss-module__WUWl4q__text",
  "title": "status-page-module-scss-module__WUWl4q__title",
});
